// Main product slider
const productSliderSettings = {
  loop: true,
  spaceBetween: 10,
  allowTouchMove: true,
  pagination: {
    el: '.product__media-pagination',
    clickable: true
  },
  breakpoints: {
    769: {
      spaceBetween: 20,
      allowTouchMove: false,
      centeredSlides: false,
      loop: false
    }
  }
}

const productSlider = new Swiper('.product__media-list', productSliderSettings);

// Sync slider with thumbnails
productSlider.on('slideChange', slider => {
  let idx = slider.realIndex;
  const activeThumb = document.querySelector('.product__media-thumbnail-item.active');
  const newThumb = document.querySelector(`.product__media-thumbnail-item[data-index="${idx}"]`);
  
  activeThumb.classList.remove('active');
  newThumb.classList.add('active');
});

// Sync thumbnails with slider
const thumbnails = document.querySelectorAll('.product__media-thumbnail-item');
thumbnails.forEach(thumbnail => {
  thumbnail.addEventListener('click', event => {
    let idx = Number(event.currentTarget.dataset.index);

    productSlider.slideTo(idx);
  });
});

customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        this.cartDrawer.open();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'announcement-bar',
        selector: '.js-open-cart'
      },
      {
        id: 'cart-icon-bubble-mobile',
        section: 'header',
        selector: '.js-open-cart'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});